import { createSessionStore, CorrelationStorage } from "./sessionStore";

const USER_KEY = "correlationUserPart";

export const createCorrelationId = ({
  storage,
  targets = [],
}: {
  storage: CorrelationStorage;
  targets?: string[];
}) => {
  const session = createSessionStore({ storage });

  const isTarget = (url: string) =>
    targets.some((target) => url.startsWith(target));

  const build = (): string => {
    const sessionPart = session.ensure();
    const userPart = storage.get(USER_KEY);
    return userPart ? `${userPart}-${sessionPart}` : sessionPart;
  };

  return {
    setUserPart: (userPart: string): void => {
      storage.set(USER_KEY, userPart);
    },
    headersFor: (url: string): Record<string, string> =>
      isTarget(url) ? { "X-Correlation-Id": build() } : {},
    get: (): string => build(),
    clear: (): void => {
      storage.remove(USER_KEY);
      session.clear();
    },
  };
};
